import React, { useState } from 'react'
import List from './List'
import AddSalesAgent from './AddSalesAgent/Main'
import SalesAgentMain from './SalesAgentMain'
export default function Main({ communityId, handleSaleAgentView }) {
    const [tab, setTab] = useState("list")
    const [editData,setEditData] =useState({})

    const handleTab = (data, pageType) => {
        setEditData(data)
        handleSaleAgentView(pageType)
        setTab(pageType)
    }
    return (
        <>
            {
                tab == "list" ?
                    <List handleTab={handleTab} communityId={communityId} />
                    : ''}

            {
                tab == "addEditsalesAgent" ?
                    <AddSalesAgent Detaildata={editData} handlePage={handleTab} ParentcommId={communityId}/>
                    : ''
            }
            {
                tab == "salesAgentDetail" ?
                    <SalesAgentMain Detaildata={editData} handlePage={handleTab} />
                    : ''
            }
        </>
    )
}
